import { Component, Input, OnInit } from '@angular/core';

export interface Column{ 
  name : string;
  description : string }

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent implements OnInit {

  @Input('data') data : Array<any>=[];
  @Input('columns') columns : Array<Column> = [];

  public rowsOnPage : number = 5;
  public sortBy : string;
  public sortOrder : string = 'desc';
  public filterBy : string ;

  constructor() { }

  ngOnInit() {}

}



// WEBPACK FOOTER //
// ./src/app/shared/components/data-table/data-table.component.ts